var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('vue-typed-js',{attrs:{"strings":_vm.strings,"typeSpeed":100,"startDelay":1000}},[_c('span',{staticClass:"typing"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }